import { Token } from 'config/types'
import { useIsDisabledFeaturedOnTelegram } from 'hooks/useTelegram'
import Column from 'layout/Components/Column'
import { ModalBody, ModalHeader } from 'UIKit/AlchemyModal'
import OpenEffect from 'UIKit/OpenEffect'
import WarningOnTelegram from 'views/Authentication/components/Wallet/WarningOnTelegram/WarningOnTelegram'
import { PAYMENT_MODAL_THEME } from 'views/Payment/MobilePayment/components/styles'
import TipForm from 'views/Payment/MobilePayment/Tip/components/TipForm'

const Tip: React.FC<{
  initialToken?: Token
  userName: string
  onDismiss: () => void
}> = ({ initialToken, userName, onDismiss }) => {
  const isDisabledFeaturedOnTelegram = useIsDisabledFeaturedOnTelegram()

  return (
    <Column height="100%" position="relative">
      <ModalHeader zIndex={1} hideStroke titleAlign="left" colorTheme={PAYMENT_MODAL_THEME} title="Tip" />
      <ModalBody
        zIndex={0}
        pb="0"
        overflow="unset"
        height="100%"
        style={{
          position: 'unset',
        }}
      >
        <OpenEffect height="100%" openType="grow" duration={0.4}>
          {isDisabledFeaturedOnTelegram ? (
            <WarningOnTelegram />
          ) : (
            <Column gap="20px" height="100%">
              <TipForm onDismiss={onDismiss} initialToken={initialToken} userName={userName} />
            </Column>
          )}
        </OpenEffect>
      </ModalBody>
    </Column>
  )
}

export default Tip
